import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, inr } from "@/lib/api";
import { CheckCircle2, MessageCircle, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function OrderSuccess() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get("/orders").then((r) => {
      const o = r.data.find((x) => x.order_number === orderNumber);
      setOrder(o);
    });
  }, [orderNumber]);

  const wa = order
    ? `https://wa.me/919096213765?text=${encodeURIComponent(`Hi Venvay, I just placed order #${order.order_number}. Please confirm.`)}`
    : "#";

  return (
    <div className="max-w-2xl mx-auto px-6 py-20 text-center">
      <CheckCircle2 size={64} className="mx-auto text-[#D4B25C]" />
      <h1 className="font-display text-5xl font-black mt-6">Order Placed</h1>
      <p className="mt-3 text-muted-foreground">Thank you for shopping with Venvay. Order confirmation sent to your email.</p>
      {order && (
        <div className="mt-8 bg-[#2A231D] border border-[#D4B25C]/15 rounded-md p-6 text-left">
          <div className="flex justify-between mb-2"><span className="label-tag">Order Number</span><span className="font-mono font-semibold">#{order.order_number}</span></div>
          <div className="flex justify-between mb-2"><span className="label-tag">Total</span><span className="font-bold text-lg text-[#D4B25C]">{inr(order.total)}</span></div>
          <div className="flex justify-between"><span className="label-tag">Payment</span><span>{order.payment_method.toUpperCase()}</span></div>
        </div>
      )}
      <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
        <a href={wa} target="_blank" rel="noreferrer" data-testid="whatsapp-confirm">
          <Button variant="outline" className="border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white">
            <MessageCircle size={16} className="mr-2" /> Confirm on WhatsApp
          </Button>
        </a>
        <Link to="/orders" data-testid="view-orders-btn"><Button className="bg-[#0A0A0A] hover:bg-[#8B2E2E]">View my orders</Button></Link>
      </div>
      <p className="mt-6 text-xs text-muted-foreground flex items-center justify-center gap-2">
        <Mail size={12} /> Order updates will be emailed to you at every step.
      </p>
    </div>
  );
}
